module.exports = __webpack_public_path__ + "img/colored-rounded.1d9137f3.svg";